import React from 'react';
import { Header } from '@/components/ui/header-2';

const Navigation = () => {
  return <Header />;
};

export default Navigation;